import { useSession } from '../../../../contexts/SessionContext'
import { useDirectDebitStatus } from '../../../../contexts/session/DirectDebitContext'

// Shared between EnterCodeSheet (code verified) and YourDetailsScreen (skipOTP - the
// backend returned no otpSessions, so there's no code to verify at all). Both reach the
// same point: bank/account/address were already collected and name-checked on
// YourDetailsScreen, so the mandate can be initiated immediately.
const useSubmitMandate = () => {
  const { initiateMandate, sessionId, sessionData } = useSession()
  const { userAddress, selectedBank, accountNumber, accountName, showOneTimeTransfer, setDetailsError } =
    useDirectDebitStatus()

  return async () => {
    try {
      const response = await initiateMandate(sessionId, {
        address: userAddress,
        bankPublicId: selectedBank.bankPublicId,
        accountNumber,
        accountName,
        referenceNumber: sessionData?.referenceNumber,
        authorizationAmount: sessionData?.metadata?.authorizationAmount,
      })
      showOneTimeTransfer(response.data)
    } catch (err) {
      setDetailsError(err.statusMessage || 'An error occurred while submitting account details')
    }
  }
}

export default useSubmitMandate
